import { Modal } from '../modal/modal';
import { OrgTreeItem } from '@employ-engage/data';
import chunk from 'lodash.chunk';
import cloneDeep from 'lodash.clonedeep';
import isEmpty from 'lodash.isempty';
import { Trans, useTranslation } from 'react-i18next';
import { UPDATE_CURRENT_COMPANY } from '../api';
import { useMutation } from '@apollo/client';

export interface DeleteOrgModalProps {
  itemLabel: string;
  path: (string | number)[];
  open: boolean;
  setOpen: (open: boolean) => void;
  completeOrgTree: OrgTreeItem;
  orgType: string;
  refetchCompany: () => void;
}

export function DeleteOrgModal({
  itemLabel,
  path,
  open,
  setOpen,
  completeOrgTree,
  orgType,
  refetchCompany,
}: DeleteOrgModalProps) {
  const [updateCompany] = useMutation(UPDATE_CURRENT_COMPANY);
  const { t } = useTranslation(['common']);
  const deleteOrg = () => {
    const clonedOrgTree = cloneDeep(completeOrgTree);
    let ref: any | [] = clonedOrgTree;

    if (isEmpty(path)) {
      // do nothing
    } else {
      chunk(path, 2).forEach((item, index, chunks) => {
        const org = item[0];
        const arrayIndex = item[1];

        if (index === chunks.length - 1) {
          ref[org] = [
            ...ref[org].slice(0, arrayIndex),
            ...ref[org].slice((arrayIndex as number) + 1),
          ];
        } else {
          ref = ref[org][arrayIndex];
        }
      });
    }

    updateCompany({ variables: { input: { orgTree: clonedOrgTree } } })
      .then(() => {
        setOpen(false);
        refetchCompany();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Modal open={open} setOpen={setOpen} panelClassName="w-full max-w-[800px]">
      <div>
        <h1 className="mb-3 text-lg font-bold">
          {t('delete-org-type', { orgType })}
        </h1>
        <p>
          <Trans i18nKey="common:deleteOrgMessage" values={{ itemLabel }}>
            Are you sure you want to delete
            <span className="font-bold">{itemLabel}</span>This action cannot be
            undone and these employees will no longer be in this group.
          </Trans>
        </p>
        <div className="mt-4 flex justify-end">
          <button className="mr-4" onClick={() => setOpen(false)}>
            {t('Cancel')}
          </button>
          <button
            onClick={deleteOrg}
            className="rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500"
          >
            {t('Delete')}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteOrgModal;
